import React, { useContext, useRef, useState } from 'react';
import { adsContext } from '../UseContext/AdsContext';
import { GoogleMap, useLoadScript, Autocomplete, Marker, Circle, } from '@react-google-maps/api';



const CreateAudience = () => {

  const { 
    audience, setAudience, 
    createAudience,
  } = useContext(adsContext);


  // ----- Radius Location -----

  // --- Google Map Plateform ---

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyAvczQH2_uIOGDXy2pRIpCUiDUnRd_OU60', // Replace with your API key
    libraries: ['places'],
  });

  const [radiusLocation, setRadiusLocation] = useState({
    includeExclude: 'include',
    place: '',
    lat: '',
    lng: '',
    radius: '1000', // 1km = 1000m
  });

  // console.log('radiusLocation : ', radiusLocation);
  // console.log('radiusLocations : ', audience.radiusLocations);

  // --- Handle While Adding Radius Location ---

  const addAutocompleteRef = useRef(null);

  // Handle autocomplete load while adding
  const handleAddAutocompleteLoad = (autocomplete) => {
    addAutocompleteRef.current = autocomplete;
  };

  // Handle place changed while adding
  const handleAddPlaceChanged = () => {
    const place = addAutocompleteRef.current.getPlace();

    if (place && place.geometry) {
      setRadiusLocation((prevState) => ({
        ...prevState,
        place: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }));
    } else {
      alert('Please select a valid location from the suggestions.');
    }
  };


  // --- Handle While Updating Radius Location ---

  const autocompleteRefs = useRef([]);

  const handleUpdateAutocompleteLoad = (index, autocomplete) => {
    autocompleteRefs.current[index] = autocomplete;
  };

  const handleUpdatePlaceChanged = (index) => {
    const place = autocompleteRefs.current[index]?.getPlace();

    if (place && place.geometry) {
      setAudience((prevState) => {
        const updatedLocations = [...prevState.radiusLocations];
        updatedLocations[index] = {
          ...updatedLocations[index],
          place: place.formatted_address,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        return { ...prevState, radiusLocations: updatedLocations };
      });
    } else {
      alert('Please select a valid location from the suggestions.');
    }
  };


  // handle add radius location
  const handleAddRadiusLocation = () => {
    // Add the new location to the list
    setAudience((prevState) => {
      return {
        ...prevState, 
        radiusLocations: [...prevState.radiusLocations, radiusLocation],
      };
    });
  
    // Clear the form fields after adding to the list
    setRadiusLocation({
      includeExclude: 'include',
      place: '',
      lat: '',
      lng: '',
      radius: '1000',
    });
  };

  // handle change radius location
  const handleChangeRadiusLocation = (index, name, value) => {
    setAudience((prevState) => {
      const updatedLocations = [...prevState.radiusLocations];

      updatedLocations[index] = {
        ...updatedLocations[index], 
        [name]: value, 
      };

      return { ...prevState, radiusLocations: updatedLocations };
    });
  };

  // handle remove radius location
  const handleRemoveRadiusLocation = (index) => {
    setAudience((prevState) => {
      const updatedLocations = prevState.radiusLocations.filter((_, i) => i !== index);
      
      return { ...prevState, radiusLocations: updatedLocations };
    });
  };


  // ----- Custom Location -----

  // const [showList, setShowList] = useState({
  //   country: false,
  //   state: false,
  //   cityInclude: false,
  //   cityExclude: false,
  // });

  // const [searchList, setSearchList] = useState({
  //   countries: [],
  //   states: [],
  //   citiesIncluded: [],
  //   citiesExcluded: [],
  // });




  
  // handle change custom location (age, gender)
  const handleChangeCustomLocation = (e) => {
    const { name, value } = e.target;
  
    setAudience((prev) => ({
      ...prev,
      customLocation: {
        ...prev.customLocation,
        [name]: value,
      },
    }));
  };



  if (!isLoaded) return <div>Loading...</div>;
  
  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light px-3 p-2 rounded-4 d-flex align-items-center justify-content-between gap-3 flex-wrap'>
          <h4 className='mb-0'>Audience</h4>

          <select className="form-select w-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>

        <div className='bg-light px-3 py-2 rounded-4 my-3'>
          <h5 className='mb-0'>Create Audience</h5>

          <small>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi, inventore!</small>
        </div>

        {/* Main */}
        <section className='d-flex flex-column flex-xl-row gap-3 mb-3'>
          {/* Left Block */}
          <div className='create-campaign-left-block bg-light p-3 rounded-3 shadow-sm'>
            {/* Audience Name */}
            <div className='mb-4'>
              <h5 className='mb-0'>Audience Name</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <input type="text" className='form-control mt-1' value={audience.name} onChange={(e) => setAudience({ ...audience, name: e.target.value })} placeholder='Enter your audience name...' />
            </div>

            {/* Location */}
            <div className='mb-5'>
              <h5 className='mb-0'>Location</h5>

              <small className='text-secondary'>Engaging Residents and Recent Visitors</small>

              {/* Radius Selection */}
              <div>
                <div className="form-check mt-4">
                  <input type="radio" className="form-check-input mt-2" id="radius" name="locationSelection" value="radius" 
                    checked={audience.locationSelection === 'radius'} onChange={(e) => setAudience({ ...audience, [e.target.name]: e.target.value })}
                  />
                  <label className="form-check-label fs-5 d-block fw-semibold" htmlFor="radius">Radius Selection</label>
                  <small className='text-secondary'>Engaging Residents and Recent Visitors</small>
                </div>

                {/* Added Radius Location */}
                <>
                  {
                    audience.radiusLocations.length > 0
                    &&
                    <div className='bg-secondary-subtle py-3 px-2 mt-3 rounded-4'>
                      {
                        audience.radiusLocations.map((value, index) => (
                          <div key={index}>
                            <div className={`d-flex flex-wrap flex-sm-nowrap align-items-center gap-3`}>
                              {/* Include/Exclude */}
                              <select className="form-select w-auto" name='includeExclude' disabled={audience.locationSelection === 'custom'}
                                value={value.includeExclude} onChange={(e) => handleChangeRadiusLocation(index, e.target.name, e.target.value)}
                                >
                                <option value="include">Include</option>
                                <option value="exclude">Exclude</option>
                              </select>

                              {/* Place */}
                              <Autocomplete
                                className='flex-grow-1'

                                onLoad={(autocomplete) => handleUpdateAutocompleteLoad(index, autocomplete)}

                                onPlaceChanged={() => handleUpdatePlaceChanged(index)}
                              >
                                <input type="search" className='form-control' name='place' placeholder="Search places here..."
                                  value={value.place} onChange={(e) => handleChangeRadiusLocation(index, e.target.name, e.target.value)}
                                />
                              </Autocomplete>

                              {/* Radius */}
                              <select className="form-select w-auto" name='radius' disabled={audience.locationSelection === 'custom'}
                                value={value.radius} onChange={(e) => handleChangeRadiusLocation(index, e.target.name, e.target.value)}
                              >
                                <option value="1000">1 km</option>
                                <option value="5000">5 km</option>
                                <option value="10000">10 km</option>
                                <option value="15000">15 km</option>
                                <option value="20000">20 km</option>
                              </select>

                              {/* Remove */}
                              <button type="button" className='btn btn-danger' disabled={audience.locationSelection === 'custom'} 
                                onClick={() => handleRemoveRadiusLocation(index)}
                              >Remove</button>
                            </div>

                            {
                              index !== audience.radiusLocations.length - 1
                              &&
                              <hr />
                            }
                          </div>
                        ))
                      }
                    </div>
                  }
                </>

                {/* Add Radius Location */}
                <div className='d-flex flex-wrap flex-sm-nowrap align-items-center gap-3 mt-3'>
                  {/* Include/Exclude */}
                  <select className="form-select w-auto" disabled={audience.locationSelection === 'custom'}
                    value={radiusLocation.includeExclude} onChange={(e) => setRadiusLocation((prev) => ({ ...prev, includeExclude: e.target.value, }))}
                  >
                    <option value="include">Include</option>
                    <option value="exclude">Exclude</option>
                  </select>

                  {/* Place */}
                  <Autocomplete
                    className='flex-grow-1'

                    onLoad={handleAddAutocompleteLoad}

                    onPlaceChanged={handleAddPlaceChanged}
                  >
                    <input type="search" className='form-control' placeholder="Search places here..." 
                      value={radiusLocation.place} 
                      onChange={(e) => 
                        setRadiusLocation((prev) => ({ 
                          ...prev, 
                          place: e.target.value, 
                          lat: '',
                          lng: '',
                        }))
                      }
                    />
                  </Autocomplete>

                  {/* Radius */}
                  <select className="form-select w-auto" disabled={audience.locationSelection === 'custom'}
                    value={radiusLocation.radius} onChange={(e) => setRadiusLocation(prev => ({ ...prev, radius: e.target.value }))}  
                  >
                    <option value="1000">1 km</option>
                    <option value="5000">5 km</option>
                    <option value="10000">10 km</option>
                    <option value="15000">15 km</option>
                    <option value="20000">20 km</option>
                  </select>

                  {/* Add */}
                  <button type="button" className='btn btn-primary' onClick={handleAddRadiusLocation} 
                    disabled={radiusLocation.place === '' || radiusLocation.lat === '' || radiusLocation.lng === '' || audience.locationSelection === 'custom'}
                  >Add</button>
                </div>

                {/* Google Map */}
                <div className='border border-danger my-3'>
                  <GoogleMap
                    zoom={radiusLocation.lat ? 10 : audience.radiusLocations.length > 0 ? 10 : 4}

                    center={
                      radiusLocation.lat
                      ?
                      {
                        lat: radiusLocation.lat, 
                        lng: radiusLocation.lng, 
                      }
                      :
                      audience.radiusLocations.length > 0
                      ? 
                      {
                        lat: audience.radiusLocations[audience.radiusLocations.length - 1].lat, 
                        lng: audience.radiusLocations[audience.radiusLocations.length - 1].lng, 
                      }
                      : 
                      { lat: 20.5937, lng: 78.9629 } // Coordinates for the center of India
                    }

                    mapContainerStyle={{
                      height: '400px',
                      width: '100%',
                    }}
                  >
                    {/* While Adding */}
                    <>
                      {
                        radiusLocation && radiusLocation.lat && radiusLocation.lng && radiusLocation.radius
                        && 
                        <React.Fragment>
                          {/* Marker for the location */}
                          <Marker
                            position={{
                              lat: radiusLocation.lat,
                              lng: radiusLocation.lng,
                            }}
                          />

                          {/* Circle for the radius */}
                          <Circle
                            center={{
                              lat: radiusLocation.lat,
                              lng: radiusLocation.lng,
                            }}

                            radius={parseInt(radiusLocation.radius, 10)} // Ensure radius is a number

                            options={{
                              strokeColor: radiusLocation.includeExclude === 'include' ? 'green' : 'red',
                              strokeOpacity: 0.8,
                              strokeWeight: 2,
                              fillColor: radiusLocation.includeExclude === 'include' ? 'green' : 'red',
                              fillOpacity: 0.35,
                            }}
                          />
                        </React.Fragment>
                      }
                    </>

                    {/* Added */}
                    <>
                      {
                        audience.radiusLocations.length > 0
                        &&
                        audience.radiusLocations.map((value, index) => (
                          <React.Fragment key={index}>
                            {/* Marker for the location */}
                            <Marker
                              position={{
                                lat: value.lat,
                                lng: value.lng,
                              }}
                            />

                            {/* Circle for the radius */}
                            <Circle
                              center={{
                                lat: value.lat,
                                lng: value.lng,
                              }}

                              radius={parseInt(value.radius, 10)} // Ensure radius is a number

                              options={{
                                strokeColor: value.includeExclude === 'include' ? 'green' : 'red',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: value.includeExclude === 'include' ? 'green' : 'red',
                                fillOpacity: 0.35,
                              }}
                            />
                          </React.Fragment>
                        ))
                      }
                    </>
                  </GoogleMap>
                </div>
              </div>

              {/* Custom Selection */}
              <div>
                <div className="form-check my-4">
                  <input type="radio" className="form-check-input mt-2" id="custom" name="locationSelection" value="custom" 
                    checked={audience.locationSelection === 'custom'} onChange={(e) => setAudience({ ...audience, [e.target.name]: e.target.value })}
                  />
                  <label className="form-check-label fs-5 d-block fw-semibold" htmlFor="custom">Custom Selection</label>
                  <small className='text-secondary'>Engaging Residents and Recent Visitors</small>
                </div>

                {/* Country */}
                <>
                  <div className='mb-4 position-relative'>
                    <h5 className='mb-2'>Country</h5>

                  </div>
                </>

                <hr className='z-1' />




                {/* State */}
                <div className='mb-4'>
                  <h5 className='mb-2'>State</h5>
                  <input type="text" className='form-control' placeholder='Search State...' />
                </div>

                <hr className='z-1' />

                {/* City */}
                <div className='mb-4'>
                  <h5 className='mb-2'>City</h5>
                  <input type="text" className='form-control' placeholder='Search City...' />
                </div>

                <hr className='z-1' />

                {/* City (Exclude) */}
                <div className='mb-4'>
                  <h5 className='mb-2'>City (Exclude)</h5>
                  <input type="text" className='form-control' placeholder='Search City To Exclude...' />
                </div>

                <hr className='z-1' />

                {/* Age */}
                <div className='mb-4'>
                  <h5 className='mb-2'>Age</h5>
                  <div className='mb-3'>
                    <label htmlFor="minAge">Min Age: </label>
                    <input type="number" id="minAge" className='mx-3' name="minAge" min="1" max="100" value={audience.customLocation.minAge} onChange={handleChangeCustomLocation} />
                  </div>

                  <div>
                    <label htmlFor="maxAge">Max Age: </label>
                    <input type="number" id="maxAge" className='mx-3' name="maxAge" min="1" max="100" value={audience.customLocation.maxAge} onChange={handleChangeCustomLocation} />
                  </div>
                </div>

                {/* Gender */}
                <div className="mb-4">
                  <h5 className="mb-2">Gender</h5>
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    {/* All */}
                    <div className="bg-white border rounded-3 p-2 d-flex align-items-center gap-2">
                      <input className="form-check-input mt-0" type="radio" name="gender" id="all" value="all" checked={audience.customLocation.gender === 'all'} onChange={handleChangeCustomLocation} />
                      <label className="form-check-label" htmlFor="all">All</label>
                    </div>

                    {/* Male */}
                    <div className="bg-white border rounded-3 p-2 d-flex align-items-center gap-2">
                      <input className="form-check-input mt-0" type="radio" name="gender" id="male" value="male" checked={audience.customLocation.gender === 'male'} onChange={handleChangeCustomLocation} />
                      <label className="form-check-label" htmlFor="male">Male</label>
                    </div>

                    {/* Female */}
                    <div className="bg-white border rounded-3 p-2 d-flex align-items-center gap-2">
                      <input className="form-check-input mt-0" type="radio" name="gender" id="female" value="female" checked={audience.customLocation.gender === 'female'} onChange={handleChangeCustomLocation} />
                      <label className="form-check-label" htmlFor="female">Female</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Hobbies, Occupation & Places Visited */}
            <div className='bg-white p-3 rounded-3 mb-3'>
              {/* Hobbies */}
              <div className='mb-4'>
                <h5 className='mb-0'>Hobbies</h5>

                <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

                <select className="form-select mt-1" name="hobbies" value={audience.hobbies} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} >
                  <option value='' disabled>Select hobby</option>
                  <option value="hobby-1">Hobby 1</option>
                  <option value="hobby-2">Hobby 2</option>
                  <option value="hobby-3">Hobby 3</option>
                  <option value="hobby-4">Hobby 4</option>
                  <option value="hobby-5">Hobby 5</option>
                </select>
              </div>

              {/* Occupation */}
              <div className='mb-4'>
                <h5 className='mb-0'>Occupation</h5>

                <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

                <select className="form-select mt-1" name="occupation" value={audience.occupation} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} >
                  <option value='' disabled>Select occupation</option>
                  <option value="occupation-1">Occupation 1</option>
                  <option value="occupation-2">Occupation 2</option>
                  <option value="occupation-3">Occupation 3</option>
                  <option value="occupation-4">Occupation 4</option>
                  <option value="occupation-5">Occupation 5</option>
                </select>
              </div>

              {/* Places Visited */}
              <div className='mb-4'>
                <h5 className='mb-0'>Places Visited</h5>

                <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

                <select className="form-select mt-1" name="placesVisited" value={audience.placesVisited} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} >
                  <option value='' disabled>Select visited places</option>
                  <option value="places-visited-1">Places Visited 1</option>
                  <option value="places-visited-2">Places Visited 2</option>
                  <option value="places-visited-3">Places Visited 3</option>
                  <option value="places-visited-4">Places Visited 4</option>
                  <option value="places-visited-5">Places Visited 5</option>
                </select>
              </div>
            </div>

            {/* Schedule */}
            <div className='bg-white p-3 rounded-3 mb-3'>
              <h5 className='mb-0'>Schedule</h5>

              <small>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia exercitationem culpa, modi dicta labore nulla laudantium ipsa quos blanditiis ipsam!</small>

              {/* Start Date */}
              <div className='mt-3'>
                <h5 className='mb-2'>Start Date</h5>

                <div className='d-flex gap-3 flex-wrap'>
                  <input type="date" className='form-control w-auto' name="startDate" value={audience.startDate} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} />
                  <input type="time" className='form-control w-auto' name="startTime" value={audience.startTime} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} />
                </div>
              </div>

              {/* End Date */}
              <div className='mt-3'>
                <h5 className='mb-2'>End Date</h5>

                <div className='d-flex gap-3 flex-wrap'>
                  <input type="date" className='form-control w-auto' name="endDate" value={audience.endDate} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} />
                  <input type="time" className='form-control w-auto' name="endTime" value={audience.endTime} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} />
                </div>
              </div>

              {/* Frequency */}
              <div className='mt-3'>
                <h5 className='mb-2'>Frequency</h5>

                <select className="form-select" name="frequency" value={audience.frequency} onChange={(e) => setAudience(prev => ({ ...prev, [e.target.name]: e.target.value }))} >
                  <option value='' disabled>Select frequency of the ad</option>
                  <option value="frequency-1">Frequency 1</option>
                  <option value="frequency-2">Frequency 2</option>
                  <option value="frequency-3">Frequency 3</option>
                  <option value="frequency-4">Frequency 4</option>
                  <option value="frequency-5">Frequency 5</option>
                </select>
              </div>
            </div>

            {/* Buttons */}
            <button type="button" className='btn btn-primary w-100' onClick={createAudience}>Create</button>
          </div>

          {/* Right Block */}
          <div className='create-campaign-right-block bg-light p-3 rounded-3 shadow-sm'>Right Block</div>
        </section> 
      </section> 
    </>
  )
}

export default CreateAudience;